




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import container from '@/container';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';
import { Invitation } from '@/dto';
import { localize as l } from '@/core/filters';

@Component
export default class InvitationComponent extends Vue {
    public invitation: Invitation | null = null;
    public isError: boolean = false;
    @Inject(CONTRACTS.FetchService) private fetchService?: FetchServiceContract;

    public async mounted() {
        this.isError = false;
        this.load(this.invitationKey);
    }

    public get invitationKey(): string {
        return this.$route.params.invitation;
    }

    public get invitationText(): string | null {
        return this.invitation
            && `${l('Invitation')} '${this.invitation!.contextName}' ${l('InvitationAs')} '${this.invitation!.role.name}'.`;
    }

    public acceptHandler() {
        this.accept(this.invitationKey)
            .then(() => this.goHome())
            .catch(() => this.showError());
    }

    public rejectHandler() {
        this.reject(this.invitationKey)
            .finally(() => this.goHome());
    }

    public async dismissHandler() {
        this.goHome();
    }

    private load(invitationKey: string) {
        return this.fetchService!
            .get<Invitation>(`/invitations/${invitationKey}`)
            .then(invitation => {
                if (invitation) {
                    this.invitation = invitation;
                } else {
                    this.showError();
                }
            })
            .catch(() => this.showError());
    }

    private accept(invitationKey: string): Promise<any> {
        return this.fetchService!.put(`/invitations/${invitationKey}/accept`, undefined);
    }

    private reject(invitationKey: string): Promise<any> {
        return this.fetchService!.put(`/invitations/${invitationKey}/reject`, undefined);
    }

    private goHome() {
        this.$router.push({ path: '/' });
    }

    private showError() {
        this.invitation = null;
        this.isError = true;
    }
}
